export default "__VITE_ASSET__Ca9xOHEV__"